<template>
    <v-dialog :value="dialog" width="900" persistent>
        <v-card class="no-scroll">
            <v-card-title class="text-h5 grey lighten-2">
                {{ excepcion ? "Redención sin emisión por excepción" : "Redención sin emisión" }}
            </v-card-title>
            <v-card-text>
                <v-form ref="formRedencion">
                    <v-row style="padding-top: 30px;">
                        <v-col cols="12" md="6">
                            <v-autocomplete v-model="alianzaId" :items="alianzasOptions" item-text="nombre"
                                item-value="id" label="Alianza" outlined dense color="#00a7e4"
                                :readonly="alianzaBloqueada" :rules="required" />
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model.trim="certificado" label="Teclear número de certificado" outlined
                                dense color="#00a7e4" :clearable="!certificadoBloqueado" :disabled="!alianzaId"
                                :readonly="certificadoBloqueado" :rules="[...required, soloNumerosRule]">
                                <template v-slot:append-outer>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span v-bind="attrs" v-on="on" class="d-flex align-center">
                                                <v-progress-circular v-if="loadingBusqueda" indeterminate size="20"
                                                    width="2" color="#00a7e4" />
                                                <v-icon v-else :color="estadoCertificado.color">
                                                    {{ estadoCertificado.icon }}
                                                </v-icon>
                                            </span>
                                        </template>
                                        <span>{{ estadoCertificado.tooltip }}</span>
                                    </v-tooltip>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-alert v-if="emisionExistente" type="warning" outlined dense>
                        El certificado <strong>{{ certificado }}</strong> ya tiene una emisión
                        ({{ emisionExistente.certificado }} - {{ emisionExistente.titular }} - Emisión: {{
                            emisionExistente.id }} ID). Usa el
                        botón
                        <v-btn class="common-botton mx-1" dark x-small @click="goToFlujoGenerico">
                            <v-icon left x-small>mdi-plus-circle</v-icon>
                            Agregar
                        </v-btn>
                        para crear la redención por el flujo normal.
                    </v-alert>

                    <v-row v-if="certificadoValidado">
                        <v-col cols="12" md="4">
                            <v-menu v-model="menuFecha" :close-on-content-click="false" offset-y min-width="auto"
                                :disabled="fechaBloqueada">
                                <template v-slot:activator="{ attrs }">
                                    <v-text-field v-model="formData.fechaNacimiento" v-bind="attrs"
                                        label="Fecha de nacimiento" placeholder="dd-mm-aaaa" maxlength="10" outlined
                                        color="#00a7e4" :rules="fechaRules"
                                        :readonly="fechaBloqueada"
                                        :append-icon="fechaBloqueada ? '' : 'mdi-calendar'"
                                        @click:append="menuFecha = true" />
                                </template>
                                <v-date-picker v-model="pickerFecha" :active-picker.sync="activePicker" :max="hoy"
                                    min="1900-01-01" locale="es-mx" color="#00a7e4" />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-autocomplete v-model="formData.productoId" :items="productos" item-text="nombre"
                                item-value="id" label="Producto" outlined color="#00a7e4" :loading="loadingProductos"
                                :rules="required" :readonly="productoBloqueado" />
                        </v-col>
                        <v-col cols="12" md="8">
                            <v-autocomplete v-model="formData.beneficioAsistencia" :items="beneficiosOptions"
                                item-text="nombre" item-value="id" label="Asistencia / Beneficio" outlined
                                color="#00a7e4" :loading="loadingBeneficios" :rules="required"
                                :disabled="!formData.productoId" />
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="formData.telefono"
                                :label="esTelefonia && !excepcion ? 'Número a recargar' : 'Número a recibir folio'"
                                type="tel" maxlength="10" outlined color="#00a7e4"
                                :rules="[...required, telefonoRule]" />
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn text outlined color="#00a7e4" style="border-radius: 15px;" @click="$emit('closeDialog')">
                    Cancelar
                </v-btn>
                <v-btn class="common-botton" dark :loading="loading" :disabled="!certificadoValidado"
                    @click="abrirConfirmacion">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
        <CommonConfirmationModal :dialog="dialogConfirmacion" @userChoice="onConfirmacion" />
    </v-dialog>
</template>

<script>
import { getEmisionByTitular } from "@/services/emision.service";
import { getProductosByAlianza } from "@/services/productos/product.service";
import { createSolicitudRedencionSinEmision } from "@/services/solicitudes/Solicitudes";
import { getBeneficiosByFilters } from "@/services/clubBeneficios/clubBeneficios";
import CommonConfirmationModal from "@/components/commonComponents/CommonConfirmationModal.vue";

export default {
    components: { CommonConfirmationModal },
    props: {
        dialog: { type: Boolean, default: false },
        excepcion: { type: Boolean, default: false },
        initialData: { type: Object, default: () => ({}) },
        alianzas: { type: Array, default: () => [] },
    },
    data() {
        return {
            telefonoRule: (v) => /^\d{10}$/.test(v) || "Debe tener 10 dígitos",
            soloNumerosRule: (v) => /^\d+$/.test(v || "") || "Solo se permiten números",
            required: [(v) => !!v || "Campo Requerido"],
            certificado: "",
            certificadoValidado: false,
            emisionExistente: null,
            beneficiosOptions: [],
            alianzaId: null,
            productos: [],
            loadingProductos: false,
            formData: {
                fechaNacimiento: "",
                productoId: null,
                beneficioAsistencia: null,
                telefono: "",
            },
            loading: false,
            loadingBusqueda: false,
            loadingBeneficios: false,
            debounceTimeout: null,
            menuFecha: false,
            activePicker: null,
            dialogConfirmacion: false,
            pendientes: { productoId: null, beneficioAsistencia: null },
        };
    },
    mounted() {
        if (this.alianzas.length === 1) this.alianzaId = this.alianzas[0].id;
        this.precargarDatos();
    },
    watch: {
        "formData.fechaNacimiento"(val) {
            const formateada = this.formatearFecha(val);
            if (formateada !== val) this.formData.fechaNacimiento = formateada;
        },
        menuFecha(val) {
            if (val) setTimeout(() => (this.activePicker = "YEAR"));
        },
        alianzaId(nueva, anterior) {
            this.productos = [];
            this.beneficiosOptions = [];
            this.formData.productoId = null;
            this.formData.beneficioAsistencia = null;
            if (anterior) {
                this.certificado = "";
                this.formData.fechaNacimiento = "";
                this.formData.telefono = "";
                this.$nextTick(() => this.$refs.formRedencion?.resetValidation());
            }

            if (!nueva) return;
            this.getProductos();
            this.programarBusqueda(this.certificado);
        },
        "formData.productoId"(nuevo) {
            this.beneficiosOptions = [];
            this.formData.beneficioAsistencia = null;
            if (nuevo) this.getBeneficios();
        },
        certificado(newVal) {
            this.programarBusqueda(newVal);
        },
    },
    beforeDestroy() {
        clearTimeout(this.debounceTimeout);
    },
    computed: {
        esTelefonia() {
            const beneficio = this.beneficiosOptions.find((b) => b.id === this.formData.beneficioAsistencia);
            return !!beneficio?.telefonia;
        },
        hoy() {
            const d = new Date();
            return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
        },
        pickerFecha: {
            get() {
                return this.esFechaValida(this.formData.fechaNacimiento)
                    ? this.formData.fechaNacimiento.split("-").reverse().join("-")
                    : null;
            },
            set(val) {
                this.formData.fechaNacimiento = val.split("-").reverse().join("-");
                this.menuFecha = false;
            },
        },
        fechaRules() {
            return [...this.required, (v) => this.esFechaValida(v) || "Fecha inválida (dd-mm-aaaa)"];
        },
        estadoCertificado() {
            if (this.loadingBusqueda)
                return { tooltip: "Buscando si el certificado ya tiene emisión en la alianza seleccionada..." };
            if (this.emisionExistente)
                return {
                    icon: "mdi-close-circle",
                    color: "error",
                    tooltip: "El certificado ya tiene emisión, usa el flujo normal (Agregar)",
                };
            if (this.certificadoValidado)
                return {
                    icon: "mdi-check-circle",
                    color: "success",
                    tooltip: "Certificado sin emisión, puedes continuar",
                };
            return {
                icon: "mdi-help-circle-outline",
                color: "grey",
                tooltip: "Teclea al menos 3 dígitos del certificado para validarlo",
            };
        },
        certificadoBloqueado() {
            return this.excepcion && !!this.initialData.certificado;
        },
        fechaBloqueada() {
            return this.excepcion
                && !!this.initialData.fechaNacimiento
                && this.esFechaValida(this.formData.fechaNacimiento);
        },
        productoBloqueado() {
            return this.excepcion
                && !!this.initialData.productoId
                && this.formData.productoId === this.initialData.productoId;
        },
        alianzasOptions() {
            if (this.alianzas.length) return this.alianzas;
            const { alianzaId, alianzaNombre } = this.initialData;
            return alianzaId ? [{ id: alianzaId, nombre: alianzaNombre || `Alianza ${alianzaId}` }] : [];
        },
        alianzaBloqueada() {
            return this.excepcion && !!this.initialData.alianzaId;
        },
    },
    methods: {
        async buscarCertificado(valor) {
            const alianza = this.alianzaId;
            try {
                const response = await getEmisionByTitular({
                    alianza_intermx_ids: [alianza],
                    certificado: valor,
                });
                if (valor !== this.certificado || alianza !== this.alianzaId) return;

                const encontrada = (response.data || []).find((e) => String(e.certificado) === valor);
                if (encontrada) this.emisionExistente = encontrada;
                else this.certificadoValidado = true;
            } catch (error) {
                if (valor === this.certificado) this.$toast.error("Error al buscar el certificado");
            } finally {
                if (valor === this.certificado && alianza === this.alianzaId) this.loadingBusqueda = false;
            }
        },
        async getProductos() {
            this.loadingProductos = true;
            try {
                this.productos = (await getProductosByAlianza(this.alianzaId)) || [];
                if (this.pendientes.productoId && this.productos.some((p) => p.id === this.pendientes.productoId)) {
                    this.formData.productoId = this.pendientes.productoId;
                }
                this.pendientes.productoId = null;
            } catch (error) {
                this.productos = [];
                this.$toast.error("Error al obtener los productos de la alianza");
            } finally {
                this.loadingProductos = false;
            }
        },
        programarBusqueda(valor) {
            this.certificadoValidado = false;
            this.emisionExistente = null;
            clearTimeout(this.debounceTimeout);

            if (!this.alianzaId || !valor || valor.length < 3 || !/^\d+$/.test(valor)) {
                this.loadingBusqueda = false;
                return;
            }
            this.loadingBusqueda = true;
            this.debounceTimeout = setTimeout(() => this.buscarCertificado(valor), 500);
        },
        async getBeneficios() {
            this.loadingBeneficios = true;
            try {
                const response = await getBeneficiosByFilters({
                    alianza_intermx_id: this.alianzaId,
                    producto_id: this.formData.productoId,
                    status: "Activo",
                });
                this.beneficiosOptions = (response || []).filter((b) => !b.especial);
                if (this.pendientes.beneficioAsistencia && this.beneficiosOptions.some((b) => b.id === this.pendientes.beneficioAsistencia)) {
                    this.formData.beneficioAsistencia = this.pendientes.beneficioAsistencia;
                }
                this.pendientes.beneficioAsistencia = null;
            } catch (error) {
                this.beneficiosOptions = [];
                this.pendientes.beneficioAsistencia = null;
                if (error.response?.status === 404) {
                    this.$toast.info("No se encontraron beneficios para el producto seleccionado");
                } else {
                    this.$toast.error("Error al obtener los beneficios");
                }
            } finally {
                this.loadingBeneficios = false;
            }
        },
        precargarDatos() {
            const { alianzaId, productoId, certificado, fechaNacimiento, beneficioAsistencia, telefono } = this.initialData;
            if (fechaNacimiento) {
                const iso = String(fechaNacimiento).slice(0, 10);
                this.formData.fechaNacimiento = /^\d{4}-\d{2}-\d{2}$/.test(iso)
                    ? iso.split("-").reverse().join("-")
                    : fechaNacimiento;
            }
            if (telefono) this.formData.telefono = telefono;
            this.pendientes = { productoId: productoId || null, beneficioAsistencia: beneficioAsistencia || null };
            if (alianzaId) this.alianzaId = alianzaId;
            if (certificado) this.certificado = String(certificado);
        },
        async guardar() {
            if (!this.certificadoValidado || !this.$refs.formRedencion.validate()) return;
            this.loading = true;

            const payload = {
                alianzaId: this.alianzaId,
                productoId: this.formData.productoId,
                idCredito: this.certificado,
                fechaNacimiento: this.formData.fechaNacimiento,
                telefono: this.formData.telefono,
                beneficioAsistencia: this.formData.beneficioAsistencia,
                ...(this.excepcion && { redencionExcepcion: true }),
            };

            try {
                const response = await createSolicitudRedencionSinEmision(payload);
                this.$emit("closeDialog");
                this.$toast.success(
                    this.excepcion
                        ? "Solicitud por excepción creada, queda pendiente de autorización"
                        : "Solicitud guardada correctamente"
                );
                window.open(this.$router.resolve("/detalles-solicitud/" + response.id).href, "_blank");
            } catch (error) {
                const msg = error.response?.data?.message || error.message;
                this.$toast.warning(msg);
            } finally {
                this.loading = false;
            }
        },
        formatearFecha(val) {
            const d = (val || "").replace(/\D/g, "").slice(0, 8);
            if (d.length <= 2) return d;
            if (d.length <= 4) return `${d.slice(0, 2)}-${d.slice(2)}`;
            return `${d.slice(0, 2)}-${d.slice(2, 4)}-${d.slice(4)}`;
        },
        esFechaValida(val) {
            if (!/^\d{2}-\d{2}-\d{4}$/.test(val || "")) return false;
            const [dia, mes, anio] = val.split("-").map(Number);
            const fecha = new Date(anio, mes - 1, dia);
            return (
                fecha.getFullYear() === anio &&
                fecha.getMonth() === mes - 1 &&
                fecha.getDate() === dia &&
                anio >= 1900 &&
                fecha <= new Date()
            );
        },
        abrirConfirmacion() {
            if (!this.certificadoValidado || !this.$refs.formRedencion.validate()) return;
            this.dialogConfirmacion = true;
        },
        onConfirmacion(confirmado) {
            this.dialogConfirmacion = false;
            if (confirmado) this.guardar();
        },
        goToFlujoGenerico() {
            if (this.excepcion) {
                this.$emit("closeDialog");
                this.$router.push("/main-hub/1");
            } else {
                this.$emit("goToFlujoGenerico");
            }
        },
    },
};
</script>

<style scoped>
.no-scroll {
    overflow: hidden !important;
}
</style>